import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import user from './authenticated/user';
import { authGuard } from './guards';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/home',
    },
    ...user,
    {
        path: '/login',
        name: 'login',
        component: () => import('../pages/auth/LoginPage.vue'),
        meta: { requiresGuest: true },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../pages/auth/RegisterPage.vue'),
        meta: {
            requiresGuest: true,
        },
    },
    
    {
        path: '/verify-otp/:email',
        name: 'verify-otp',
        component: () => import('../pages/auth/VerifyOTPPage.vue'),
        meta: {
            requiresAuth: false,
            requiresGuest: false,
        },
    },
    
    {
        path: '/recovery-password',
        name: 'recovery-password',
        component: () => import('../pages/RecoveryPasswordPage.vue'),
        meta: { requiresGuest: true },
    },
    {
        path: '/password-setup/:email',
        name: 'password-setup',
        component: () => import('../pages/auth/SetupPasswordPage.vue'),
        meta: {
            requiresAuth: false,
            requiresGuest: false,
        },
    },
    

    {
        path: '/logout',
        name: 'logout',
        component: () => import('../pages/auth/LogoutPage.vue'),
        meta: {
            requiresAuth: false,
            requiresGuest: false,
        },
    },
    {
        path: '/terms-and-conditions',
        name: 'terms-and-conditions',
        component: () => import('../pages/cms/CmsPage.vue'),
        meta: { slug: 'terms_and_conditions' },
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: () => import('../pages/cms/CmsPage.vue'),
        meta: { slug: 'privacy_policy' },
    },
    {
        path: '/not-authorized',
        name: 'not-authorized',
        component: () => import('../pages/NotAuthorizedPage.vue'),
    },
    {
        path: '/:catchAll(.*)',
        name: 'not-found',
        component: () => import('../pages/Error404Page.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH || process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

// Attach the authGuard globally
router.beforeEach(authGuard);

export default router;
